<template>
  <div :class="{ 'full-screen': isFullScreen }">
    <!-- {{ date }} -->
    <!-- object_name: {{ resourceSchema.object_name }} -->
    <!-- {{ filteredData.length }}
    {{ filteredDataRecords ? filteredDataRecords.length : 0 }} -->
    <v-dialog v-model="showCopyCrew" max-width="450">
      <v-copy-crews :currentDate="d" :refreshCrew="reload"></v-copy-crews>
    </v-dialog>

    <v-toolbar flat>
      <!-- <v-btn @click="addResource()" color="info" text>{{ addBtnTitle }}</v-btn> -->
      <v-search-on-page className="ml-4"></v-search-on-page>
      <v-spacer />
      <v-btn small @click="showCopyCrew = !showCopyCrew" text
        ><v-icon class="ma-2">mdi-calendar-multiple</v-icon>Copy Crews</v-btn
      >
      <v-spacer />
      <!-- {{ crewDate }} -->
      <v-spacer />
      <v-btn text @click="reload()"
        ><v-icon class="ma-2">mdi-reload</v-icon></v-btn
      >
      <v-tooltip v-if="!isMobile && !noFullScreen" top>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon @click="toggleFullScreen">
            <v-icon v-if="!isFullScreen">mdi-fullscreen</v-icon>
            <v-icon round color="error" v-else>mdi-fullscreen-exit</v-icon>
          </v-btn>
        </template>
        <span>Toggle Full Screen</span>
      </v-tooltip>
    </v-toolbar>
    <v-tabs scrollable v-if="showTimeTabs" v-model="currentTab">
      <v-tab v-for="t in time" :key="t.value">{{ t.value }}</v-tab>
    </v-tabs>
    <!-- resources: {{ resources }} -->
    <v-skeleton-loader
      v-if="loading"
      :loading="loading"
      type="heading,table-tbody"
      loading-text="Loading Crew..."
      style="height: 200px;"
    ></v-skeleton-loader>

    <v-resizable-split
      :startWidthPercent="startWidthPercent"
      leftPaneColor="blue lighten-4"
      rightPaneColor="red lighten-3"
      v-else
    >
      <!-- Left Pane Content -->
      <template v-slot:left>
        <div style="width:100%" class="ml-2 mt-0 data-col">
          <d-table
            v-if="crewTableReady && resourceSchema"
            v-bind="resourceSchema['v-bind']"
            :data_object="crewSchema"
            table_name="day_crew"
            :dropItem="handleDrop"
            :hideTitle="true"
            :noFullScreen="true"
            :hasSearch="true"
            :key="tableKey"
            :defaultModel="defaultCrewModel"
            :droppedObjectFilterProperty="dataResource"
            :dropName="dataName"
            :onDataReceived="onDataReceived"
            :expandedItemsTitle="scheduledDataName"
            :noRefreshButton="true"
            :editData="filteredResources || resources"
            :droppedObjects="
              (filteredData || []).filter((r) => {
                return r[dataResource];
              })
            "
            ref="dTable"
            :getRowClass="getRowClass"
            :droppedObjectTemplate="dataTemplate"
          />
        </div>
      </template>

      <!-- Right Pane Content -->
      <template v-slot:right>
        <div
          :style="{ width: '100%', 'max-height': wrapHeight }"
          :key="dataKey"
          class="ma-2 data-col unsassigned-col"
        >
          <v-text-field
            hide-details
            v-model="searchQuery"
            clearable
            prepend-inner-icon="mdi-magnify"
            label="Search"
          ></v-text-field>
          <table style="width:100%">
            <tr>
              <th>
                {{ dataName }}
              </th>
            </tr>

            <tr>
              <td>
                <v-card
                  v-if="
                    filteredData &&
                      !filteredData.some((r) => {
                        return !r[dataResource];
                      })
                  "
                  class="empty-data pa-2"
                  @drop="handleDataDrop(r)"
                  @dragover.prevent
                ></v-card>
              </td>
            </tr>
            <tr
              class="data-col  mt-3"
              v-for="d in filteredData.filter((r) => {
                return !r[dataResource];
              })"
              :key="d._id"
            >
              <td>
                <v-card
                  v-if="isTime(d)"
                  class="mt-2"
                  draggable="true"
                  @dragstart="handleDataDragStart($event, d)"
                  @drop="handleDataDrop(d)"
                  @dragover.prevent
                >
                  <!-- <v-btn
                  color="info"
                  @click="linkClick(d)"
                  v-if="link"
                  small
                  text
                  >{{ d[link] }}</v-btn
                >
                {{ formatTime(d[timeName]) }} -->
                  <v-card-text v-html="dataTemplate(d)"></v-card-text>
                </v-card>
              </td>
            </tr>
          </table>
        </div>
      </template>
    </v-resizable-split>
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import vuedraggable from "vuedraggable";
export default {
  name: "ResourceScheduler",
  components: {
    DTable: () => import("./Table.vue"),
    vuedraggable,
    VCrew: () => import("./Crew.vue"),
    VCopyCrews: () => import("./CopyCrews.vue"),
    VFormCard: () => import("./FormCard.vue"),
    VSearchOnPage: () => import("./SearchOnPage.vue"),
    VResizableSplit: () => import("./ResizableSplit.vue"),
  },
  props: {
    linkClick: Function,
    link: String,
    data: Array,
    resources: Array,
    filteredResources: Array,
    time: Array,
    dataName: String,
    scheduledDataName: String,
    resourceName: String,
    resourceSchema: Object,
    additionalModel: Object,
    addBtnTitle: String,
    dataTemplate: Function,
    dataTitle: String,
    resourceTemplate: Function,
    resourceTitle: String,
    dataResource: String,
    timeName: String,
    update: Function,
    resourceLink: String,
    resourceLinkClick: Function,
    date: String,
    d: String,
    helpText: String,
    helpTitle: String,
    addDefaultResources: Function,
    getQry: Function,
    allRecords: Boolean,
    resourceFilter: Function,
    getRowClass: Function,
    filteredDataRecords: Array,
    showTimeTabs: Boolean,
  },
  data() {
    return {
      dataKey: 0,
      dataTimeKey: 0,
      searchQuery: "",
      currentTab: 0,
      resourceTable: null,
      crewSchema: null,
      crewTableReady: false,
      defaultResources: [],
      defaultCrewModel: {},
      droppedObjects: [],
      tableKey: 0,
      showCopyCrew: false,
      crewDate: "",
      loading: false,
      startWidthPercent: 60,
      isFullScreen: false,
      wrapHeight: "",
    };
  },
  activated() {
    // this.tableKey = !this.tableKey;
    // if (this.d) {
    //   this.crewDate = fun.convertDateFormat(this.d);
    // }
  },
  mounted() {
    if (this.d) {
      this.crewDate = fun.convertDateFormat(
        fun.formatDate(this.d, false, false, true)
      );
    }

    var that = this;
    // this.$root.$on("itemsDeleted", (c) => {
    //   if (c.table_name == "day_crew") {
    //     c.selected.forEach((s) => {
    //       //
    //     });
    //   }
    //   that.reload();
    //   console.log(c);
    // });
    this.$root.$on("calTabChanged", (c) => {
      that.d = c.d;
      that.tableKey = !that.tableKey;
    });
    this.$root.$on("tableHeightUpdated", (c) => {
      if (c.tableName == "Daily Crew") {
        console.log(c.wrapHeight);
        var increasedHeight = parseInt(c.wrapHeight) + 50;

        that.wrapHeight = increasedHeight + "px !important";
      }
    });
    //
    if (that.addDefaultResources) {
      that.addDefaultResources(this);
    }

    this.defaultCrewModel = {
      resources: that.defaultResources,
      crew_date: this.d,
    };
    // this.$root.$on("tableEditRecord", (obj) => {
    //   if (!obj.rec) {
    //     obj.rec = {};
    //     that.addDefaultResources();
    //     obj.rec.resources = that.defaultResources;
    //     obj.tbl.table.push(obj.rec);
    //   }
    // });
    this.crewSchema = this.resourceSchema;
    this.crewSchema.schema = {
      properties: this.resourceSchema.properties,
      "v-bind": this.resourceSchema["v-bind"],
    };
    this.crewSchema.all_records = this.allRecords;
    this.crewSchema.qry = this.getQry ? this.getQry(that) : {} || {};
    this.crewSchema.date_fileds = this.resourceSchema.date_fields || [];
    // this.crewSchema = {
    //   // object_name: this.resourceSchema.object_name,
    //   qry: this.getQry ? this.getQry(that) : {} || {},
    //   date_fileds: this.resourceSchema.date_fields || [],
    //   all_records: this.allRecords,
    //   schema: {
    //     properties: this.resourceSchema.properties,
    //   },
    // };
    // this.addDefaultResources();
    this.crewTableReady = true;
    that.tableKey = !that.tableKey;
  },
  beforeDestroy() {},
  methods: {
    toggleFullScreen() {
      this.isFullScreen = !this.isFullScreen;
      // this.$refs.dTable.isFullScreen = !this.$refs.dTable.isFullScreen;
      this.$refs.dTable.updateHeight(this.isFullScreen);
    },
    reload() {
      var par = fun.getParentByProperty(this, "customDayClick");
      // if (par) {
      //   par.customDayClick(this.d);
      // }
      // this.$refs.dTable.loadFromDb();
      this.tableKey = !this.tableKey;
      this.dataKey = !this.dataKey;
      // par.resourceKey = !par.resourceKey;
    },
    dropItem(item) {
      console.log(item);
    },
    onDataReceived(data, d) {
      // console.log(data);
      console.log(this.$refs.dTable.wrapHeight);

      // wrapHeight
      if (this.resourceFilter) {
        data = this.resourceFilter(data);
      }
      return data;
    },

    // addDefaultResources() {
    //   if (!this.defaultResources.length) {
    //     this.defaultResources = [];
    //     this.additionalModel.vehicle_type
    //       .filter((t) => {
    //         return t.default;
    //       })
    //       .forEach((t) => {
    //         this.defaultResources.push({
    //           resource_type: t.vehicle_type,
    //           resource_category: "vehicle",
    //         });
    //       });
    //     this.additionalModel.employee_role
    //       .filter((t) => {
    //         return t.default;
    //       })
    //       .forEach((t) => {
    //         this.defaultResources.push({
    //           resource_type: t.employee_role,
    //           resource_category: "labor",
    //         });
    //       });
    //   }
    // },
    addResource() {
      console.log(this.resources);
    },
    getAvailability(r) {
      var that = this;
      if (!r.availability) {
        return "";
      }
      var weekDay = new Date(this.date).getDay();
      var weekDayAvailable =
        !r.availability ||
        !r.availability.weekdays ||
        r.availability.weekdays[weekDay];
      var availability = "";
      var periods = r.availability.periods;
      var calendar = r.availability.calendar;
      if (periods && periods.length) {
        periods.forEach((p) => {
          if (p) {
            var from = new Date(p.period.split("-")[0]);
            var to = new Date(p.period.split("-")[1]);
            var curDate = new Date(this.date);
            if (curDate >= from && curDate <= to) {
              availability = r.full_name + " is not available " + p.comments;
            }
          }
        });
      }
      if (calendar && calendar.length) {
        calendar.forEach((c) => {
          var from = new Date(c.start);
          var to = new Date(c.end);
          var curDate = new Date(this.date);
          if (this.compareDates(from, curDate)) {
            if (c.closed && that.time[that.currentTab].value == c.closed) {
              availability =
                r.full_name + " is not available in the " + c.closed;
            }
          }
        });
      }

      var t =
        !weekDayAvailable.available ||
        weekDayAvailable.available[this.currentTab];
      if (t) {
        var part = Object.keys(t)[0];
        if (t[part] && t[part].closed) {
          availability =
            r.full_name +
            " is not available " +
            weekDayAvailable.day +
            " " +
            part;
        }
      }
      return availability;
    },

    getDataObject(r) {
      var dataObject = {
        object_name: "employee",
        model: r,
        schema: this.resourceSchema,
      };
      return dataObject;
    },
    formatTime(d) {
      var date = new Date(d);
      return (
        fun.padZero(date.getHours()) + ":" + fun.padZero(date.getMinutes())
      );
    },
    compareDates(date1, date2) {
      if (
        new Date(date1).getDate() === new Date(date2).getDate() &&
        new Date(date1).getMonth() === new Date(date2).getMonth() &&
        new Date(date1).getFullYear() === new Date(date2).getFullYear()
      ) {
        return true;
      }
    },
    isTime(r) {
      var t = this.time[this.currentTab];
      return !t || this.recTimed(r, t);
    },

    recTimed(d, t) {
      // var rec = this.getDataRec(d);
      var rec = d;
      if (rec) {
        if (rec[this.timeName]) {
          var hrs = new Date(rec[this.timeName]).getHours();
          // if (!hrs) {
          //   return true;
          // }
          if (t && t.start <= hrs && hrs <= t.end) {
            return true;
          }
        }
      }
      return false;
    },
    getDataRec(d) {
      var rec = this.filteredData.filter((r) => {
        return r[this.dataResource] && r[this.dataResource]._id == d._id;
      })[0];

      return rec;
    },
    handleDataDragStart(event, item) {
      // Store the data being dragged
      event.dataTransfer.setData("text/plain", JSON.stringify(item));
    },

    handleDrop(event, time, resource, jobsInCrew, curIndex) {
      if (this.getAvailability(resource)) {
        return;
      }
      const e = JSON.parse(event.dataTransfer.getData("text/plain"));
      var rec = this.data.find((d) => {
        return d[this.dataResource] && d[this.dataResource]._id == e._id;
      });
      if (!rec) {
        //drag from data
        rec = e;
      }
      rec[this.dataResource] = resource;
      // console.log(this.data[0][this.dataResource]);
      this.dataKey = !this.dataKey;
      this.dataTimeKey = !this.dataTimeKey;
      try {
        rec[this.dataResource].num_jobs += 1;
      } catch (error) {
        //
      }

      this.update(resource, rec._id, jobsInCrew, curIndex);

      // Here you can handle the dropped data, maybe assign it to the resource
      // based on the time and resource info
      // For example:
      // this.assignDataToResource(data, time, resource);
    },
    handleTimeSlotDragStart(event, e, resource) {
      // var e = this.getDataRec(resource);
      event.dataTransfer.setData("text/plain", JSON.stringify(e));
      // event.dataTransfer.setData(
      //   "text/plain",
      //   JSON.stringify({ type: "timeSlot", time, resource })
      // );
    },
    handleDataDrop(data) {
      const e = JSON.parse(event.dataTransfer.getData("text/plain"));

      var rec = this.filteredData.find((d) => {
        return d[this.dataResource] && d._id == e._id;
      });
      if (!rec) {
        return;
      }

      let parRec = this.resources.find((r) => {
        return (
          rec && rec[this.dataResource] && r._id == rec[this.dataResource]._id
        );
      });
      if (rec) {
        try {
          parRec.num_jobs -= 1;
        } catch (error) {
          //
        }
      }

      rec[this.dataResource] = "";
      this.update("", e._id, parRec, this);

      this.dataKey = !this.dataKey;
      this.dataTimeKey = !this.dataTimeKey;

      // if (droppedData.type === "timeSlot") {
      //   // Handle time slot item dropped back to data
      //   // Here, you can move the item back to the data section or handle it accordingly
      // }
    },
  },

  computed: {
    filteredData() {
      var fRecs = this.filteredDataRecords
        ? this.filteredDataRecords
        : this.data.length
        ? this.data
        : [];

      if (!this.searchQuery) {
        return fRecs;
      }

      const query = this.searchQuery.toLowerCase();

      const filtered = fRecs.filter((item) => {
        // Iterate over all keys of the item and check if any of them match the search query
        return Object.values(item).some((value) => {
          if (typeof value === "string") {
            return value.toLowerCase().includes(query);
          } else if (typeof value === "number") {
            // Convert number to string and check for match without converting to lowercase
            return value.toString().includes(this.searchQuery);
          }
          return false;
        });
      });

      return filtered.length ? filtered : []; // Return empty array if no matches
    },
  },
};
</script>

<style lang="css" scoped>
.data-col {
  /* height: 100%; */
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  /* ✅ Ensures children align to the top */
  display: flex;
  flex-direction: column;

  justify-content: flex-start; /* Align children to the top */
}
.unsassigned-col {
  height: 100%;
}
.res-card {
  /* height: 200px; */
  overflow: auto;
}

.data-card {
  /* height: 200px; */
  max-width: 90%;

  overflow: auto;
}
.full-screen {
  max-height: 100vh !important;
  height: 100vh !important;
  overflow-y: initial !important;
}
.time-card {
  /* height: 220px;
    overflow: auto; */
  min-height: 200px;
  height: 100%;
  align-self: stretch;
  /* border: 1px solid; */
}

.time-card-wrap {
  vertical-align: top;
  /* min-height: 200px; */
  align-items: stretch;
  /* border: solid; */
  /* display: flex; */
}

.theme--light
  .data-card
  .theme--light
  .data-card
  .theme--light
  .time-card-wrap {
  background: transparent;
  color: black;
}

.v-card {
  background: transparent !important;
}

.theme--dark .data-card .theme--dark .data-card {
  background: transparent;
  color: white;
}

.empty-data {
  height: 60vh;
  /* border: dashed 1px gray; */
}

.empty-resource-data {
  height: 150px;
  width: 100px;
  overflow: hidden;
  /* border: dashed 1px gray; */
}

.resource-title {
  white-space: nowrap;
}

/* Light Theme */
.theme--light table tbody tr:nth-child(odd) {
  /* background-color: #f2f2f257;  Light gray for odd rows */
}

/* Dark Theme */
.theme--dark table tbody tr:nth-child(odd) {
  /*  background-color: #555; Slightly lighter dark color for odd rows */
}

table tbody tr {
  border-bottom: 1px solid #55555580;
}

table tbody td {
  border-right: 1px solid #55555580;
}

thead {
  /* position: fixed; */
}
</style>
